// Property Card Connect Section - Card connect settings
import React from 'react';
import { FormSection, NumericFormField } from '@/components/common/admin/form';

interface PropertyCardConnectSectionProps {
  creditCardMerchantAccountId: string;
  achMerchantAccountId: string;
  onCreditCardChange: (value: string) => void;
  onAchChange: (value: string) => void;
  disabled?: boolean;
}

export const PropertyCardConnectSection: React.FC<PropertyCardConnectSectionProps> = ({
  creditCardMerchantAccountId,
  achMerchantAccountId,
  onCreditCardChange,
  onAchChange,
  disabled,
}) => {
  return (
    <FormSection title="Card Connect Settings">
      <NumericFormField
        label="Credit Card Merchant Account ID"
        value={creditCardMerchantAccountId}
        onChangeText={onCreditCardChange}
        placeholder="Optional"
        editable={!disabled}
      />

      <NumericFormField
        label="ACH Merchant Account ID"
        value={achMerchantAccountId}
        onChangeText={onAchChange}
        placeholder="Optional"
        editable={!disabled}
      />
    </FormSection>
  );
};

